import { gql } from '@/__generated__';

export const GET_ORGANIZATION_NAME = gql(`#graphql
  query GetOrganizationName($input: OrganizationInput) {
    organization(input: $input) {
      id
      name
    }
  }
`);
